import { View, Text } from 'react-native';
import React from 'react';

const CalendarEventScreen = (event) => {
  return (
    <View style={{ flex: 1 }}>

    </View>
  )
}
export default CalendarEventScreen;